import { render } from "./MetricIssueDetailPage.vue?vue&type=template&id=53134806&scoped=true"
import script from "./MetricIssueDetailPage.vue?vue&type=script&lang=js"
export * from "./MetricIssueDetailPage.vue?vue&type=script&lang=js"

import "./MetricIssueDetailPage.vue?vue&type=style&index=0&id=53134806&lang=less&scoped=true"

import exportComponent from "/aqua/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53134806"]])

export default __exports__